const dcfOrderLookupEndpoint = "/pay/orderlookup";
const dcfOrderConfirmationEndpoint = "/mail/appcan/order-confirm";
const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const today = new Date();
var deliveryConfirmationDate = new Date(today);
deliveryConfirmationDate = new Date(deliveryConfirmationDate.setDate(deliveryConfirmationDate.getDate() + 1));
var excludeDays = ['02-20','04-07','05-23','07-01','08-01','09-05','10-10','11-11','12-25','12-26'];
//Add today's year to array elements
excludeDays = excludeDays.map(el => `${today.getFullYear()}-` + el);
//Add next year's new year to array elements
excludeDays.push(`${today.getFullYear()+1}-01-01`);

function dcfFormatPhoneNo(phoneNo){
    var f_val = phoneNo.replace(/\D[^\.]/g, "");
    phoneNo = f_val.slice(0,3)+"-"+f_val.slice(3,6)+"-"+f_val.slice(6);
    return phoneNo;
};
function thankYouFunction (orderDetailsJson) {
    $(`#dcf-order-block-${orderDetailsJson['order_number']}`).css("filter","blur(5px)");
    $(`#dcf-order-block-${orderDetailsJson['order_number']}`).after(`<div class="dcf-thankyou-popup"><p>Thank You for confirming <strong>${orderDetailsJson['delivery_date']}</strong> as your delivery date for order <strong>${orderDetailsJson['order_number']}</strong>.</p></div>`);
};
// Step 3 send emails:
async function dcfConfirmOrder(orderDetails,newDate) {
    var deliveryDate, prevDeliveryDate='', emailBody='', orderDetailsJson={};
    orderDetails = orderDetails.split("|");
    if (newDate) {
        deliveryDate = new Date(newDate);
        deliveryDate = `${months[deliveryDate.getMonth()]} ${deliveryDate.getDate()}, ${deliveryDate.getFullYear()}`
        prevDeliveryDate = orderDetails[1];
        emailBody = `The delivery window for this customer's order was closed and they have chosen a new delivery date (Previous delivery date: ${prevDeliveryDate}). Please review and contact the customer immediately if the new delivery date is required`;
    } else {
        deliveryDate = orderDetails[1];
        emailBody = "This order was confirmed for the original delivery date";
    };
    orderDetailsJson["order_number"] = orderDetails[0];
    orderDetailsJson["delivery_date"] = deliveryDate;
    orderDetailsJson["previous_delivery_date"] = prevDeliveryDate;
    orderDetailsJson["customer_name"] = orderDetails[2];
    orderDetailsJson["customer_number"] = orderDetails[3];
    orderDetailsJson["email_body"] = emailBody;
    //send the json object to email
    try {
        const dcfOrderConfirmationResponse = await window.IntegrationLibrary.TLIB.Cart.request({
            method: 'POST',
            endpoint: dcfOrderConfirmationEndpoint,
            data: orderDetailsJson,
        });
        if (dcfOrderConfirmationResponse['message'] == 'success') {
            thankYouFunction(orderDetailsJson);
        }
    } catch (err) {
        console.log("error", err);
    };
};
// Sundays and holidays mentioned above are excluded from delivery days
function disableDates(date) {
    var date = new Date(date);
    var string = $.datepicker.formatDate("yy-mm-dd", date);
    if (date.getDay()==0) {
        return [false];
    } else {
        return (($.inArray(string,excludeDays)<0)? [true] : [false]);
    }
};
function dcfPickDate(id) {
    $(id).datepicker("destroy");
    $(id).datepicker();
    $(id).datepicker("option", {
        beforeShowDay: disableDates,
        dateFormat: "yy-mm-dd",
        minDate: deliveryConfirmationDate,
        maxDate: "+4w"
    });
    $(id).datepicker("show");
};
function dcfConfirmnewDate(orderDetails, newDateId){
    if ($(newDateId).val()) {
        dcfConfirmOrder(orderDetails,$(newDateId).val());
        $(newDateId).removeClass("error");
    } else {
        $(newDateId).addClass("error");
    }

};
$(document).ready(function(){
    (function () {
        //set up Order lookup (step 1) page
        function init(){
            $('#shopify-section-dcf-order-lookup').removeClass("hidden");
            $('#shopify-section-dcf-order-details').addClass("hidden");
            //$('#shopify-section-dcf-thank-you').addClass("hidden");
            $('#error-no-orders').addClass("hidden");
            $("#error-fail-response").addClass("hidden");
        };
        //set up Order display (step 2) page
        function dcfSetUpOrderDetails() {
            $('#shopify-section-dcf-order-lookup').addClass("hidden");
            $('#shopify-section-dcf-order-details').removeClass("hidden");
            //$('#shopify-section-dcf-thank-you').addClass("hidden");
            $('#error-no-orders').addClass("hidden");
            $("#dcf-back-step1").on("click",function(){init();});
        };

        function orderLookupOnSuccess(dcfOrderLookupResponse){
            var orders = dcfOrderLookupResponse;
            var orderHtml = `<h2 class="h3 text-center vertical-margin-large"><strong>Step 2</strong> &mdash; Review your order(s)</h2><p class="dcf-orders-found">We found ${orders.length} orders`;
            for (var i=orders.length-1; i >= 0; i--) {
                var orderItems = orders[i]['items'];
                var confirmBtnError = '', datePickerPlace = '', btnLinkText, btnLink, beforeDelivery;
                var delivery_date = new Date(orders[i]['delivery_date']);
                var delivery_month = months[delivery_date.getMonth()];
                var delivery_day = delivery_date.getDate();
                var delivery_year = delivery_date.getFullYear();
                if (deliveryConfirmationDate <= delivery_date) {
                    beforeDelivery = true;
                } else {
                    beforeDelivery = false;
                };
                if (orders[i]['status'] == 'open') {
                    if (orders[i]['conf_stat_cd'] != 'CON') {
                        if (orders[i]['totals']['balance'] != 0) {
                            confirmBtnError = '<p class="dcf-balance-remaining-error">Please pay the remaining balance and wait for our Confirmations Department to call you before you proceed</p>';
                            btnLinkText = "Take me to easy pay page";
                            btnLink = 'href="/pages/ac-easy-pay" class="btn btn-primary dcf-btn margin-top-large xs-margin-top-small"';
                        } else {
                            var orderInfo = `${orders[i]['number']}|${delivery_month} ${delivery_day}, ${delivery_year}|${orders[i]['shipping_address']['first_name']} ${orders[i]['shipping_address']['last_name']}|${orders[i]['shipping_address']['phone_main']}`;
                            if (beforeDelivery == true) {
                                btnLinkText = "Confirm this order";
                                btnLink = `id="dcf-confirm-${orders[i]['number']}" class="btn btn-primary dcf-btn margin-top-large xs-margin-top-small" onclick="${dcfConfirmOrder.name}('${orderInfo}')"`;
                            } else {
                                confirmBtnError = '<p class="dcf-balance-remaining-error">Deliveries are Closed for this date</p>';
                                btnLinkText = "Confirm with a new date";
                                btnLink = `id="dcf-pickDate-${orders[i]['number']}" class="btn btn-primary dcf-btn margin-top-large xs-margin-top-small" onclick="${dcfConfirmnewDate.name}('${orderInfo}','#datePicker-${orders[i]['number']}')"`;
                                datePickerPlace = `<div class="dcf-above-btn"><label for="datePicker-${orders[i]['number']}">Pick a new Date</label><input type="text" class="datepicker-field" readonly id="datePicker-${orders[i]['number']}" onclick="${dcfPickDate.name}('#datePicker-${orders[i]['number']}')"></input></div>`;
                            }
                        }
                    } else {
                        btnLinkText = "Order has been confirmed";
                        btnLink = 'class="btn btn-primary dcf-btn margin-top-large xs-margin-top-small" disabled';
                    }
                } else {
                    btnLinkText = "Order Status Closed";
                    btnLink = 'class="btn btn-primary dcf-btn margin-top-large xs-margin-top-small" disabled';
                }
                var prodListitems = ``;
                for (var j=0; j < orders[i]['items'].length; j++) {
                    prodListitems += `<div class="dcf-list-row"><div class="dcf-prod-list-cell"><span id="sku">${orderItems[j]['sku']}</span></div><div class="dcf-prod-list-cell"><span id="prod-name">${orderItems[j]['name']}</span></div><div class="dcf-prod-list-cell"><span id="qty">${orderItems[j]['qty']}</span></div><div class="dcf-prod-list-cell"><span id="price">${orderItems[j]['price']}</span></div></div>`;
                }
                if (orders[i]['shipping_address']['address2'] != "") {
                    var customerAddress = `${orders[i]['shipping_address']['address1']}, ${orders[i]['shipping_address']['address2']}, ${orders[i]['shipping_address']['city']}, ${orders[i]['shipping_address']['province_code']}, ${orders[i]['shipping_address']['postcode']}`;
                } else {
                    var customerAddress = `${orders[i]['shipping_address']['address1']}, ${orders[i]['shipping_address']['city']}, ${orders[i]['shipping_address']['province_code']}, ${orders[i]['shipping_address']['postcode']}`;
                }
                orderHtml += `<div class="row" id="${orders[i]['number']}"><div class="col-xs-12"><div class="dcf-order-container margin-bottom-medium"><h3><strong>Order# ${orders[i]['number']}</strong></h3><div class="dcf-order-block margin-top-medium" id="dcf-order-block-${orders[i]['number']}"><div class="dcf-customer-details"><p><strong>Customer Name:</strong><br><span id="customer-name">${orders[i]['shipping_address']['first_name']} ${orders[i]['shipping_address']['last_name']}</span></p><p><strong>Customer Shipping Address:</strong><br><span id="customer-shipping-address">${customerAddress}</span></p><p><strong>Delivery Date:</strong><br><span id="delivery_date">${delivery_month} ${delivery_day}, ${delivery_year}</span></p><p><strong>Customer Code:</strong><br><span id="customer-code">${orders[i]['customer_code']}</span></p><p><strong>Order Status:</strong><br><span id="order-status">${orders[i]['status']}</span></p><p><strong>Order Total:</strong><br><span id="order-total">$${orders[i]['totals']['total_price']}</span></p><p><strong>Balance Due:</strong><br><span id="order-balance-due">$${orders[i]['totals']['balance']}</span></p><div class="dcf-btn-wrapper">${confirmBtnError}${datePickerPlace}<a ${btnLink}>${btnLinkText}&nbsp;&nbsp;&nbsp;<i class="fas fa-angle-right"></i></a></div></div><div class="dcf-product-details"><p><strong>Products</strong></p><div class="dcf-prod-list"><div class="dcf-list-row"><div class="dcf-prod-list-cell"><span id="sku"><strong>SKU</strong></span></div><div class="dcf-prod-list-cell"><span id="prod-name"><strong>Product Name</strong></span></div><div class="dcf-prod-list-cell"><span id="qty"><strong>Qty</strong></span></div><div class="dcf-prod-list-cell"><span id="price"><strong>Price</strong></span></div></div>${prodListitems}</div></div></div></div></div></div>`;
            };
            orderHtml += '<div class="col-xs-12 col-sm-6 col-md-4"><div class="dcf-btn-wrapper margin-top-large xs-margin-top-small"><a href="javascript:void(0);" id="dcf-back-step1" class="btn btn-primary dcf-go-back-btn"><i class="fas fa-angle-left"></i>&nbsp;&nbsp;Go To Step-1</a></div></div>';
            $("#dcf-step2-container").html(orderHtml);
            dcfSetUpOrderDetails();
        }
        
        //Process order lookup page (Step 1);
        async function submitDcfForm(formData, currentBtn) {           
           // setLoader();
            try {
                const dcfOrderLookupResponse = await window.IntegrationLibrary.TLIB.Cart.request({
                    method: 'POST',
                    endpoint: dcfOrderLookupEndpoint,
                    data: formData,
                });
                if(dcfOrderLookupResponse.hasOwnProperty("success")){
                    if(dcfOrderLookupResponse.success === false){
                        $('#error-no-orders').text(dcfOrderLookupResponse.message); // no orders returned, show message below form    	
                        $('#error-no-orders').removeClass("hidden");
                    }
                } else {	
                    orderLookupOnSuccess(dcfOrderLookupResponse, formData);
                }
            } catch(err) {
                $("#error-fail-response").removeClass("hidden");
                console.log(err);
            } finally {
                currentBtn.data('requestRunning', false);
            }
            
        }
        if (today.getHours() < 21 && today.getDay() != 0 && today.getDay() != 7) {
            // Handle Validations for Step 1 (Order lookup page)
            $("#dcf-FIO-form-submit").on('click',function(e){
                var currentBtn = $(this);
                e.preventDefault();

                var dcfSalesOrderNo = $("#dcfSalesOrderNo").val();
                var dcfPhoneNo =  $("#dcfPhoneNo").val();
                var dcfPostalCode =  $("#dcfPostalCode").val();
                var canadaPostalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

                var dcfSalesOrderNoValidate = false;
                var dcfPhoneNoValidate = false;
                var dcfPostalCodeValidate = false;
                if(dcfSalesOrderNo == '' || dcfSalesOrderNo.length > 12 || dcfSalesOrderNo.length < 11) {
                    dcfSalesOrderNoValidate = true;
                }
                if(dcfPhoneNo === '' || dcfPhoneNo.length != 10 ) {
                    dcfPhoneNoValidate = true;
                }

                if(dcfPostalCode === '' || !canadaPostalCodeRegex.test(dcfPostalCode)) {
                    dcfPostalCodeValidate = true;
                }
                if(dcfSalesOrderNoValidate === true){
                    $(".invalid-sales-order-no").removeClass("hidden");
                    $("#invalid-sales-order-no").addClass("error-box");
                } else {
                    $(".invalid-sales-order-no").addClass("hidden");
                    $("#invalid-sales-order-no").removeClass("error-box");
                }
                if(dcfPhoneNoValidate === true){
                    $(".invalid-phone-no").removeClass("hidden");
                    $("#invalid-phone-no").addClass("error-box");
                } else {
                    $(".invalid-phone-no").addClass("hidden");
                    $("#invalid-phone-no").removeClass("error-box");
                }
                if(dcfPostalCodeValidate === true){
                    $(".invalid-dcfPostalCode").removeClass("hidden");
                    $("#invalid-dcfPostalCode").addClass("error-box");
                }
                else{
                    $(".invalid-dcfPostalCode").addClass("hidden");
                    $("#invalid-dcfPostalCode").removeClass("error-box");
                }
                //Submit form if no validation errors
                if(dcfSalesOrderNoValidate === false && dcfPhoneNoValidate === false && dcfPostalCodeValidate === false){

                    //prevent double/multiple click on submit button and avoid multiple api calls
                    if ( currentBtn.data('requestRunning') ) {
                        return;
                    }
                    currentBtn.data('requestRunning', true);

                    var input = {};

                    input["delDoc"] = dcfSalesOrderNo.toUpperCase();
                    input["phone"] = dcfFormatPhoneNo(dcfPhoneNo).toUpperCase();
                    input["postcode"] = dcfPostalCode.replace(/\s+/g, '').toUpperCase();
                    $("#error-fail-response").addClass("hidden");
                    
                    submitDcfForm(input, currentBtn);
                }		
            });
        } else {
            $("#dcfSalesOrderNo").attr("disabled", true);
            $("#dcfPhoneNo").attr("disabled", true);
            $("#dcfPostalCode").attr("disabled", true);
            $("#dcf-FIO-form-submit").attr("disabled", true);
            $("#dcf-FIO-form-submit").addClass("disabled");
            $("#error-fail-response").text("Confirmation form is only available Mony to Fridday before 9 pm");
            $("#error-fail-response").removeClass("hidden");
        }
    })();
});